import fetchMerchandiseList from 'actions/merchandise/fetchMerchandiseList'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type ReturnType = [
  Array<App.MerchandiseSearchAdvert>,
  boolean,
  Error | undefined,
]

interface Options {
  disabled?: boolean
}

function useMerchandiseList(filters: App.MerchandiseFilters | undefined, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()

  const key = getObjectKey(filters ?? {})
  const merchandiseList = useAppSelector(state => state.merchandise.merchandiseLists[key])
  const fetching = useAppSelector(state => state.merchandise.fetchingMerchandiseLists[key])
  const error = useAppSelector(state => state.merchandise.merchandiseListErrors[key])

  useEffect(() => {
    if (!options.disabled && filters) {
      dispatch(fetchMerchandiseList(filters))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, key, options.disabled])

  return [
    merchandiseList ?? EmptyArray,
    (!!fetching || !merchandiseList) && !options.disabled,
    error,
  ]
}

export default useMerchandiseList
